import React, { useState } from 'react'
import { Minus, Plus } from 'lucide-react'

/**
 * Accordion row matching the Prosperity FAQ pattern.
 *
 * @param {object} props Question text and answer content.
 * @returns {React.ReactElement} Expandable FAQ/troubleshooting item.
 */
const ZoomAccordionItem = ({ question, children, id }) => {
  const [isOpen, setIsOpen] = useState(false)
  const uniqueId = id || String(question).replace(/\s+/g, '-').toLowerCase()

  return (
    <div className='accordion-item faq-item-wrapper border-0 border-bottom'>
      <h3 className='accordion-header' id={`zoom-heading-${uniqueId}`}>
        <button
          className='accordion-button px-0 py-4 font-heading fs-5 fw-medium d-flex justify-content-between align-items-center bg-transparent shadow-none'
          type='button'
          onClick={() => setIsOpen(!isOpen)}
          aria-expanded={isOpen}
          aria-controls={`zoom-collapse-${uniqueId}`}>
          <span className='me-auto font-heading sub-title-2 text-rich-navy pe-3'>
            {question}
          </span>
          {isOpen ? (
            <Minus
              className='flex-shrink-0 text-gold-light'
              style={{ width: '24px', height: '24px' }}
            />
          ) : (
            <Plus
              className='flex-shrink-0 text-gold-light'
              style={{ width: '24px', height: '24px' }}
            />
          )}
        </button>
      </h3>
      <div
        id={`zoom-collapse-${uniqueId}`}
        className={`accordion-collapse collapse prosperity-accordion ${
          isOpen ? 'show' : ''
        }`}
        aria-labelledby={`zoom-heading-${uniqueId}`}>
        <div className='accordion-body px-0 py-0 text-slate-gray mb-24px font-paragraph small-paragraph fw-medium lh-relaxed'>
          {children}
        </div>
      </div>
    </div>
  )
}

export default ZoomAccordionItem
